import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import moment from "moment";

import Select from "react-select";
import CommonGrid from "../../components/CommonGrid";
import {
  BlurWrapper,
  BlurWrapperWithSpan,
  DateConvert,
  DollarConvert,
  FloatLabel,
  LoadingButton,
  LoanAccCustomNewTabCell,
  SpinnerBlock,
  customStylesForMultiSelect,
} from "../../Utils/CustomComponent";
import { HeartFill } from "react-bootstrap-icons";
import urls from "../../Utils/urls";
import {
  dateRangeConst,
  intialStateRND,
  reportGridColumn2RND,
} from "./constantRND";
import classes from "./reports.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../axios";
import { toast } from "react-toastify";
import {
  commonToast,
  convertList,
  reportListConverter,
  toTitleCase,
} from "../../Utils";
import CustomBreadCrumbs from "../../components/CustomBreadCrumbs";
import { useForm } from "react-hook-form";
import FormBox from "../../components/FormBox/FormBox";
import { useAbortController } from "../../hooks/useAbortController";
import { fetchReportDetail } from "../../store/reducers/reportDocumentSlice/api";

const OneRunNewReport1 = () => {
  // const chooseReportLabelListRND = reportListConverter(
  //   useSelector((state) => state.RS_Authentication.reportList)
  // );
  // const chooseReportLabelListRND = reportListConverter(
  //   useSelector((state) => state.reportDocument.reportList.data)
  // );
  const chooseReportLabelListRND = convertList(
    useSelector((state) => state.reportDocument.reportList.data)
  );
  // const options = useSelector(
  //   (state) => state.reportDocument.runNewReport?.options
  // );
  const reportName = useSelector(
    (state) => state.reportDocument.runNewReport?.reportName
  );
  const selectSPApi = useSelector(
    (state) => state.reportDocument.runNewReport?.report
  );

  const propStateData = useSelector(
    (state) => state.reportDocument.runNewReport?.propState
  );
  const propStateLenders = useSelector(
    (state) => state.reportDocument.runNewReport?.lenderID
  );
  const reportDetail = useSelector(
    (state) => state.reportDocument.reportDetail.data
  );
  const optionsStatus = useSelector(
    (state) => state.reportDocument.reportDetail.status
  );
  const isSavedReport = useSelector(
    (state) => state.reportDocument.isSavedReport
  );
  const options = reportDetail?.options;

  const { signal } = useAbortController();
  const navigate = useNavigate();
  const lenderId = useSelector((state) => state.account.selectedAccount);
  const [lenderLoan, setLenderLoan] = useState([lenderId] || []);
  const [loading, setLoading] = useState(false);
  const [reportLoading, setReportLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [favourite, setFavourite] = useState(false);
  const [title, setTitle] = useState(null);
  const [CustomReportName, setCustomReportName] = useState("Anonymous");
  const [errorMsg, setErrorMsg] = useState(null);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [reportGridColumn, setReportGridColumn] = useState(null);
  const [columnData, setColumnData] = useState(null);
  // const [updatedOptions, setUpdatedOptions] = useState([]);
  // const [propState, setPropState] = useState(propStateData || intialStateRND);
  const userId = localStorage.getItem("apex_userid");
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
    .value;
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value
  );

  const defaultValues = options
    ?.map((data) => data.field)
    .reduce((a, v) => ({ ...a, [v]: `${intialStateRND[v]}` }), {});

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues });

  const dispatch = useDispatch();

  useEffect(() => {
    if (optionsStatus === "idle") {
      dispatch(fetchReportDetail({ reportId: selectSPApi?.report_id, signal }));
    }
  }, [dispatch, selectSPApi?.report_id, optionsStatus]);

  useEffect(() => {
    if (propStateData)
      propStateData?.map((data) => setValue(data.field, data.value));
    if (propStateLenders) setLenderLoan(propStateLenders);
  }, [propStateData, propStateLenders, setValue]);
  // const updatedOptions = options?.map((data) => ({
  //   ...data,
  //   value: watch(data.field),
  // }));

  const updatedOptions = isSavedReport
    ? options?.map((option) => ({
        ...option,
        value: watch(option.field),
        defaultValue: watch(option.field) ?? intialStateRND?.[option.field],
      }))
    : options?.some((item) => item.field === "date_range")
    ? options
        .map((obj) => {
          if (obj.field === "date_range") {
            const filteredOptions = obj.options.filter(
              (opt) => opt.field === "date_range"
            );
            const otherOptions = obj.options.filter(
              (opt) => opt.field !== "date_range"
            );

            return [
              {
                ...obj,
                options: filteredOptions[0]?.options,
                defaultValue: `TODAY`,
                value: watch(filteredOptions[0]?.field),
              },
              ...otherOptions.map((opt) => ({
                ...opt,
                defaultValue: opt?.defaultValue
                  ? opt.defaultValue
                  : `${intialStateRND?.[opt.field]}`,
                value: watch(opt.field),
              })), // Treat each non-date_range option as a separate entity
            ];
          }
          return {
            ...obj,
            defaultValue:
              obj.type === "lenderSelect"
                ? lenderId
                : `${intialStateRND?.[obj.field]}`,
            value: watch(obj.field),
          };
        })
        .flat()
    : options?.map((data) => ({
        ...data,
        defaultValue:
          data.type === "lenderSelect"
            ? lenderId
            : `${intialStateRND?.[data.field]}`,
        value: watch(data.field),
      }));

  useEffect(() => {
    if (!reportName) {
      navigate("/run-new-report");
    }
  }, [navigate, reportName]);
  useEffect(() => {
    if (errors) {
      toast.error();
    }
    setTimeout(() => {}, 1000);
  }, [errors]);

  const handleRun = async (data) => {
    if (selectSPApi?.value && lenderLoan?.length) {
      setLoading(true);
      setReportLoading(true);
      setColumnData(null);
      setErrorMsg(null);
      setTitle(
        chooseReportLabelListRND?.filter(
          (data) => data.value === selectSPApi?.value
        )?.[0]?.label || "label"
      );

      const id = toast.loading("Run New Report Pending");
      try {
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
          },
        };
        const payload = () => {
          const payObj = {};
          updatedOptions?.forEach((data) => {
            if (data.type === "date") {
              payObj[data.field] = moment(data.value).format("DD/MM/yyyy");
            } else if (data.type === "lenderSelect") {
              payObj[data.field] = data?.value?.label?.split(":")[1].trim(" ");
            } else {
              payObj[data.field] = !isNaN(data.value)
                ? Number(data.value)
                : data.value || "";
            }
          });
          // return {
          //   lenderID: lenderLoan?.map((data) => data.value).join(" "),
          //   ...payObj,
          // };
          return {
            reportname: selectSPApi.value,
            report_id: selectSPApi?.report_id,
            roletype: selectedRole,
            jsonInput: {
              lenderID: lenderLoan?.map((data) => data.value).join(" "),
              ...payObj,
            },
          };
        };

        let res = await axios.post(
          urls.reportsNDocuments.updatedGetReports(),
          // urls.reportsNDocuments.getReports(selectSPApi?.value),
          payload(),
          headers
        );

        // hide Columns
        const userPrefResp = await axios.get(
          urls.reportsNDocuments.getUserPrefrence(userId, userRole),
          { signal }
        );
        const reportColumnHideAvailable =
          userPrefResp?.data?.user_preferences?.filter(
            (data) => data?.reportName === selectSPApi?.value
          )?.[0];
        if (reportColumnHideAvailable?.reportName?.length > 0) {
          const hColumResult = reportColumnHideAvailable?.columnData
            ?.filter((data) => data.isVisible === false)
            ?.map((data) => data.key);
          setHiddenColumns(hColumResult);
        } else {
          // if (res.data?.[0]?.[0]) {
          if (res.data?.RESULTSET?.[0]) {
            // const columnHideByDefault = Object.keys(res.data?.[0]?.[0])?.map(
            const columnHideByDefault = Object.keys(
              res.data?.RESULTSET?.[0]
            )?.map((data) => ({
              key: data,
              isVisible: true,
            }));
            await axios.post(
              urls.reportsNDocuments.postSaveUserPrefrence(),
              {
                user_id: userId,
                user_role: userRole,
                user_preferences: {
                  reportName: selectSPApi?.value,
                  columnData: columnHideByDefault,
                },
              },
              headers
            );
          }
        }
        // hide Column End
        toast.update(id, {
          render: "Successfully Report Fetched",
          type: "success",
          isLoading: false,
          ...commonToast,
        });

        // const newdata = res.data?.[0]?.map((data) => {
        const newdata = res.data?.RESULTSET?.map((data) => {
          const accountSplit = data?.["Loan Account"]
            ?.split("loan/")[1]
            ?.split("/");
          if (accountSplit) {
            const accountId = accountSplit[0];
            const formattedAccount = data?.["Loan Account"]
              .split(">")[1]
              .split("<")[0];
            return {
              ...data,
              loan_id: accountId,
              account: formattedAccount,
              "Loan Info": data?.["Loan Info"]?.replace(/<br\s*\/?>/gi, " "),
            };
          }
          return data;
        });

        res = {
          ...res,
          data: [newdata, res.data?.[1]],
        };

        setReportGridColumn(
          res.data?.[0]?.[0]
            ? Object.keys(res.data[0][0])
                ?.filter(
                  (data) =>
                    data !== "account" && data !== "loan_id" && data !== ""
                )
                ?.map((data) => {
                  let obj = {
                    field: data,
                    title: toTitleCase(data),
                    style: { wordBreak: "break-all" },
                    Cell: ({ value }) => (
                      <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>
                    ),
                  };
                  if (data === "Loan Account") {
                    obj = {
                      field: "account",
                      title: toTitleCase(data),
                      Cell: (props) => (
                        <LoanAccCustomNewTabCell props={props} />
                      ),
                      style: { wordBreak: "break-all" },
                    };
                  } else if (
                    data?.toLowerCase()?.includes("amount") ||
                    data?.toLowerCase()?.includes("interest") ||
                    data?.toLowerCase()?.includes("investment") ||
                    data?.toLowerCase()?.includes("payemnt") ||
                    data?.toLowerCase()?.includes("charge") ||
                    data?.toLowerCase()?.includes("fund") ||
                    data?.toLowerCase()?.includes("principal") ||
                    data?.toLowerCase()?.includes("fee") ||
                    data?.toLowerCase()?.includes("other") ||
                    data?.toLowerCase()?.includes("prinbal") ||
                    data?.toLowerCase()?.includes("origbal") ||
                    data?.toLowerCase()?.includes("balance")
                  ) {
                    obj = {
                      field: data,
                      title: toTitleCase(data),
                      Cell: (props) => <DollarConvert props={props} />,
                      style: { wordBreak: "break-all" },
                    };
                  } else if (data?.toLowerCase()?.includes("date")) {
                    obj = {
                      field: data,
                      title: toTitleCase(data),
                      style: { wordBreak: "break-all" },
                      Cell: (props) => <DateConvert props={props} />,
                    };
                  }
                  return obj;
                })
            : reportGridColumn2RND
        );
        setColumnData(res.data[0]);
        setReportLoading(false);
        if (res.data.message === "some error occured") {
          setReportLoading(false);
          setLoading(false);
          setErrorMsg("some error occured");
          toast.update(id, {
            render: "SOME ERROR OCCURED",
            type: "error",
            isLoading: false,
            ...commonToast,
          });
        }
      } catch (error) {
        setReportLoading(false);
        console.error(error);
      } finally {
        setTimeout(() => {
          toast.dismiss();
        }, 1000);
      }
    } else {
      setReportLoading(false);
    }
  };

  const handleSave = async () => {
    setSaveLoading(true);
    const id = toast.loading("Save New Report Pending");
    try {
      // const headers = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // };
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
        },
      };

      const updatedOptions1 = updatedOptions.map((item) => ({
        ...item,
        defaultValue: item.value ? item.value : item?.defaultValue,
      }));

      const payload = () => {
        return {
          is_active: "Y",
          user_id: userId,
          user_role: userRole,
          report_details: {
            report_custom_name: CustomReportName,
            lenderID: lenderLoan,
            report: selectSPApi,
            propState: updatedOptions1,
            favorite: favourite,
          },
          report_type: "SAVED",
        };
      };
      await axios.post(
        urls.reportsNDocuments.postSaveReport(),
        payload(),
        headers
      );
      setSaveLoading(false);
      toast.update(id, {
        render: "Saved Report Successfully!",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
      navigate("/reports-and-documents");
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "SOME ERROR OCCURED",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setTimeout(() => {
        toast.dismiss();
      }, 1000);
    }
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eee", minHeight: "92vh" }}
      >
        <CustomBreadCrumbs
          crumbs={[
            { title: "Reports & Documents", link: "/reports-and-documents" },
            { title: "Run New Report", link: "/run-new-report" },
            { title: reportName, link: "" },
          ]}
        />
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <Form>
              <Form.Group controlId="formBasicEmail" className="col-sm-6">
                {updatedOptions?.find(
                  (option) => option.type === "lenderSelect"
                )
                  ? null
                  : selectSPApi?.value !== "LLQ_report_Sage_Macro" &&
                    selectSPApi?.value !== "LLQ_report_Sage_Micro" && (
                      <div className={"m-3"}>
                        <FloatLabel
                          label={"Selected Lenders"}
                          value={lenderLoan}
                        >
                          <BlurWrapper>
                            <Select
                              name="lenderLoan"
                              isMulti
                              options={[
                                { label: "Select All", value: "all" },
                                ...accountOptions,
                              ]}
                              value={lenderLoan ? lenderLoan : null}
                              isClearable={lenderLoan?.length > 1}
                              onChange={(selected) => {
                                selected?.length &&
                                selected.find(
                                  (option) => option.value === "all"
                                )
                                  ? setLenderLoan(accountOptions.slice(0))
                                  : setLenderLoan(selected);
                              }}
                              placeholder=""
                              required
                              styles={customStylesForMultiSelect}
                            />
                          </BlurWrapper>
                        </FloatLabel>{" "}
                      </div>
                    )}

                {optionsStatus === "fulfilled" ? (
                  <FormBox
                    options={updatedOptions}
                    register={register}
                    watch={watch}
                    setValue={setValue}
                  />
                ) : (
                  <SpinnerBlock />
                )}
              </Form.Group>
            </Form>
            <Button
              className="mt-5 btn btn-primary text-white btn-outline py-3 px-4 me-3"
              onClick={handleSubmit(handleRun)}
              disabled={reportLoading || optionsStatus === "loading"}
            >
              Run
            </Button>

            {loading && columnData && (
              <>
                <Button
                  className="mt-5 me-3"
                  onClick={() => setFavourite(true)}
                >
                  <HeartFill style={{ color: favourite ? "red" : "white" }} />
                </Button>
                <Form.Group className="mb-3 mt-5 col-sm-6">
                  <Form.Label>Report Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Custom Report Name"
                    onChange={(e) => {
                      setCustomReportName(e.target.value);
                    }}
                  />
                </Form.Group>
                <LoadingButton
                  loading={saveLoading}
                  disabled={saveLoading}
                  onClick={handleSave}
                  className="mt-5 me-3 btn btn-primary text-white"
                  title={"Save"}
                />
              </>
            )}
            <Button
              className="mt-5 btn btn-primary text-white btn-outline py-3 px-4 me-3"
              disabled={optionsStatus !== "fulfilled"}
              onClick={() => {
                const updatedOptions1 = updatedOptions.map((item) => ({
                  ...item,
                  defaultValue: item.value ? item.value : item?.defaultValue,
                  disable: true,
                }));

                localStorage.setItem(
                  "reportDetailsInfoForScheduledReports",
                  JSON.stringify({
                    lenderID: lenderLoan,
                    report: selectSPApi,
                    propState: updatedOptions1,
                    favorite: favourite,
                  })
                );
                navigate("/schedule-report");
              }}
            >
              Schedule Report
            </Button>
            <section className="row d-flex flex-row align-items-stretch justify-content-stretch">
              {loading &&
                (columnData ? (
                  <CommonGrid
                    className={
                      reportGridColumn?.length <= 10
                        ? classes.pastDue15
                        : reportGridColumn?.length <= 20
                        ? classes.pastDue25
                        : classes.pastDue35
                    }
                    hideColumn={true}
                    hiddenColumns={hiddenColumns}
                    selectSPApi
                    title={title}
                    tHeight={"65vh"}
                    gridColumns={reportGridColumn}
                    columnData={columnData ? columnData : null}
                    commonGridData={
                      columnData ? { columnData: columnData } : null
                    }
                    reportLenders={lenderLoan}
                  />
                ) : (
                  <SpinnerBlock height={"30vh"} />
                ))}
              <div className="bg-red">{errorMsg}</div>
            </section>
          </section>
        </article>
      </section>
    </div>
  );
};

export default OneRunNewReport1;
